import React, { ReactNode } from 'react'
import { cn } from '~shared/utils/cn' // Добавьте расширение .ts, если требуется

interface ButtonProps {
  children: ReactNode
  className?: string
  onClick?: () => void
}

export const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  onClick
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'flex items-center justify-center  h-fit duration-300 ease-out',
        className
      )}>
      {children}
    </button>
  )
}
